import { __assign } from "tslib";
import React, { useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import MoreSuggestionsDropdown from '../MoreSuggestionsDropdown';
import { getCurrentSuggestion, getRandomSuggestion } from '../../../../util';
import s from './CommentSuggestions.scss';
var CommentSuggestions = function (_a) {
    var suggestions = _a.suggestions, maxVisible = _a.maxVisible, onSelect = _a.onSelect;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var logBiEvent = useBiLogger();
    var mobileUpdates = useFlag('comment_suggestions_mobile');
    var commentSuggestionsRandom = useFlag('comment_suggestions_random');
    // BI receives a stringified array of tuples as the list of suggestions
    var biSuggestionsValue = useMemo(function () {
        return suggestions.map(function (i18nKey, idx) {
            var isVisible = idx < maxVisible ? 1 : 0;
            return [t(i18nKey), isVisible];
        });
    }, [t, suggestions, maxVisible]);
    var commonBiData = useMemo(function () { return ({
        itemid: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        creatorid: BiContextProvidedValue,
        comment_suggestions: JSON.stringify(biSuggestionsValue),
    }); }, [biSuggestionsValue]);
    var visibleSuggestions = suggestions.slice(0, maxVisible);
    var menuSuggestions = suggestions.slice(maxVisible);
    var menuItems = useMemo(function () {
        return menuSuggestions.map(function (i18nKey, idx) {
            var suggestionText = t(i18nKey);
            return {
                label: "".concat(suggestionText, "..."),
                value: "".concat(suggestionText, " "),
                biData: BiData(__assign(__assign({ evid: 191 }, commonBiData), { selected_suggestions: suggestionText, rank: maxVisible + idx + 1, is_shown: 0, is_surprise_me: 0 })),
            };
        });
    }, [t, menuSuggestions, commonBiData, maxVisible]);
    useEffect(function () {
        logBiEvent(BiData(__assign({ evid: 190 }, commonBiData)));
    }, [logBiEvent, commonBiData]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cn(s['suggestions-container'], mobileUpdates && s['mobile-updates']) },
            commentSuggestionsRandom && (React.createElement(PlainButtonOrLink, { className: cn(s['button'], s['suggestion'], s['random']), onClick: function () {
                    onSelect(getRandomSuggestion(suggestions));
                    logBiEvent(BiData(__assign(__assign({ evid: 191 }, commonBiData), { selected_suggestions: getCurrentSuggestion(), rank: 0, is_shown: 1, is_surprise_me: 1 })));
                } }, t('commentbox.surpriseMe'))),
            visibleSuggestions.map(function (i18nKey, idx) {
                var suggestionText = t(i18nKey);
                return (React.createElement(PlainButtonOrLink, { key: "suggestion-".concat(idx), className: cn(s['button'], s['suggestion']), onClick: function () { return onSelect("".concat(suggestionText, " ")); }, biData: BiData(__assign(__assign({ evid: 191 }, commonBiData), { selected_suggestions: suggestionText, rank: idx + 1, is_shown: 1, is_surprise_me: 0 })) }, "".concat(suggestionText, "...")));
            })),
        !isMobile || mobileUpdates ? (React.createElement(MoreSuggestionsDropdown, { items: menuItems, commonBiData: commonBiData, buttonClassName: s['button'], onSelect: onSelect })) : null));
};
export default CommentSuggestions;
//# sourceMappingURL=CommentSuggestions.js.map